import { Box } from '@alf/uikit';
import { BonusItem } from './BonusItem';

import styles from './index.module.css';

export const PromotionsBonusItemWrapper = ({
  promo,
  promoItemActiveId,
  togglePromoItem
}) => (
  <Box
    className={styles.bonusItemWrapper}
    data-role="bonus-item-wrapper"
    direction="column"
    align="center"
  >
    <BonusItem
      bonus={promo}
      togglePromoItem={togglePromoItem}
      promoItemActiveId={promoItemActiveId}
    />
  </Box>
);
